import Vue from "vue"
import Vuex from "vuex"
Vue.use(Vuex)


let store = new Vuex.Store({
    state: {
        addressInfo: {},
        insurerInfo: {},
        insurerprice: "",
        phone: ""
    },
    mutations: {
        addressinfo(state, data) {
            // console.log(data);
            state.addressInfo = data
        },
        setinsurerInfo(state, data) {
            state.insurerInfo = data
        },
        insurerprice(state, data) {
            state.insurerprice = data
        },
        phone(state, data) {
            state.phone = data
        }
    },
    actions: {},
    modules: {

    }
})
export default store